var slides = document.getElementsByClassName('itineraries-one-slider--item');

var prevButton = document.getElementById('inspiring-button-prev');
var nextButton = document.getElementById('inspiring-button-next');


var upNext = document.getElementsByClassName('upnext-link--itineraries');

var slidesLength = slides.length;

if (prevButton) {
    prevButton.addEventListener('click', function() {
        if (prevButton.classList.contains('active')) {
            var PrevactiveSlide = document.getElementsByClassName('itineraries-one-slider--item active');
            var prevSlide = PrevactiveSlide[0].parentNode.previousElementSibling.firstChild.nextElementSibling;
            var dataID = prevSlide.getAttribute('data-id');

            prevSlide.classList.add('active');
            PrevactiveSlide[1].classList.remove('active');  

            if (dataID == 0) {
                nextButton.classList.remove('disabled');
                prevButton.classList.remove('active');
                prevButton.classList.add('disabled');
            } else {
                nextButton.classList.remove('disabled');
            }
        } else {
            //Do nothing
        }
    })
}

if (nextButton) {
    nextButton.addEventListener('click', function() {
        if (nextButton.classList.contains('disabled')) {
            //Do nothing
        } else {
            var activeSlide = document.getElementsByClassName('itineraries-one-slider--item active');
            var nextSlide = activeSlide[0].parentNode.nextElementSibling.firstChild.nextElementSibling;
            nextSlide.classList.add('active');
            var dataID = nextSlide.getAttribute('data-id');
            activeSlide[0].classList.remove('active');  

            if (dataID == slidesLength - 1) {
                nextButton.classList.add('disabled');
                prevButton.classList.remove('disabled');
                prevButton.classList.add('active');
            } else {
                nextButton.classList.remove('disabled');
                prevButton.classList.remove('disabled');
                prevButton.classList.add('active');
            }
        }
    })
}

//Accordions

var accs = document.getElementsByClassName('itinerary-details--item-title');
var o;

for (o = 0; o < accs.length; o++) {
  accs[o].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

if (upNext) {
    for (let i = 0; i < upNext.length; i++) {
        upNext[i].addEventListener('click', function() {
            slides[i].classList.remove('active');
            slides[i + 1].classList.add('active');

            if (i + 1 == slidesLength - 1) {
                nextButton.classList.add('disabled');
                prevButton.classList.remove('disabled');
            } else {
                nextButton.classList.remove('disabled');
                prevButton.classList.remove('disabled');
                prevButton.classList.add('active');
            }

            // for (var o = 0; o < slidesLength; o++) {
            //     slides[o].classList.remove('active');
            // }
            // slides[i + 1].classList.add('active');
        })
    }
}